import { render, staticRenderFns } from "./SingleCartItem.vue?vue&type=template&id=0baf3a0e&"
import script from "./SingleCartItem.vue?vue&type=script&lang=js&"
export * from "./SingleCartItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports